var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineSearch16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.803 13.8637C13.0959 14.1566 13.5708 14.1566 13.8637 13.8637C14.1566 13.5708 14.1566 13.0959 13.8637 12.803L12.803 13.8637ZM10.5833 6.66667C10.5833 8.82978 8.82978 10.5833 6.66667 10.5833V12.0833C9.65821 12.0833 12.0833 9.65821 12.0833 6.66667H10.5833ZM6.66667 10.5833C4.50355 10.5833 2.75 8.82978 2.75 6.66667H1.25C1.25 9.65821 3.67512 12.0833 6.66667 12.0833V10.5833ZM2.75 6.66667C2.75 4.50355 4.50355 2.75 6.66667 2.75V1.25C3.67512 1.25 1.25 3.67512 1.25 6.66667H2.75ZM6.66667 2.75C8.82978 2.75 10.5833 4.50355 10.5833 6.66667H12.0833C12.0833 3.67512 9.65821 1.25 6.66667 1.25V2.75ZM13.8637 12.803L10.5303 9.46966L9.46966 10.5303L12.803 13.8637L13.8637 12.803Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineSearch16);
export default __webpack_public_path__ + "static/media/outline-search-16.d290a11e.svg";
export { ForwardRef as ReactComponent };